export default __webpack_public_path__ + "static/media/Wh.9fd134b2.jpg";